export { default as rolesReducers } from 'roles/reducers/roles_reducers';



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/reducers/index.js